import React from 'react';
import { Checkbox, Label } from './checkbox';

const PROTEIN_OPTIONS = [
  { id: 'chicken', label: 'Chicken' },
  { id: 'beef', label: 'Beef' },
  { id: 'pork', label: 'Pork' },
  { id: 'turkey', label: 'Turkey' },
  { id: 'shrimp', label: 'Shrimp' },
  { id: 'white fish', label: 'White Fish' },
  { id: 'meatless', label: 'Meatless' },
  { id: 'salmon', label: 'Salmon' },
  { id: 'tuna', label: 'Tuna' },
];

const MealFilters = ({ 
  expandedSections, 
  toggleSection, 
  proteinFilters, 
  handleProteinFilterChange, 
  handleToggleAllProteins, 
  maxPrepTime, 
  setMaxPrepTime, 
  menuTypeFilters, 
  handleMenuTypeFilterChange,
  searchQuery,
  setSearchQuery
}) => {
  return (
    <div className="space-y-4 mb-8">
      {/* Filters Toggle */}
      <div className="bg-white rounded-lg shadow-sm">
        <button 
          onClick={() => toggleSection('filters')}
          className="w-full text-left text-2xl font-bold capitalize flex items-center justify-between hover:text-blue-600 transition-colors bg-white p-4 rounded-lg"
        >
          <div>
            Filters
          </div>
          <svg
            className={`w-6 h-6 transform transition-transform ${expandedSections.includes('filters') ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>

      {expandedSections.includes('filters') && (
        <div className="p-6 space-y-8 bg-white rounded-b-lg shadow-sm">
          {/* Protein Type */}
          <div>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Protein Type</h3>
              <button
                onClick={handleToggleAllProteins}
                className="text-sm text-blue-600 hover:text-blue-800"
              >
                {proteinFilters.length === PROTEIN_OPTIONS.length ? 'Unselect all Protein' : 'Select all Protein'}
              </button>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {PROTEIN_OPTIONS.map((option) => (
                <div key={option.id} className="flex items-center space-x-2">
                  <Checkbox
                    id={option.id}
                    checked={proteinFilters.includes(option.id)}
                    onCheckedChange={() => handleProteinFilterChange(option.id)}
                  />
                  <Label htmlFor={option.id}>{option.label}</Label>
                </div>
              ))}
            </div>
          </div>

          {/* Prep Time */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Maximum Prep Time</h3>
            <div className="space-y-4">
              <div className="relative">
                <input
                  type="range"
                  min="10"
                  max="90"
                  step="5"
                  value={maxPrepTime}
                  onChange={(e) => setMaxPrepTime(Number(e.target.value))}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                  style={{
                    background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${(maxPrepTime - 10) / 80 * 100}%, #e5e7eb ${(maxPrepTime - 10) / 80 * 100}%, #e5e7eb 100%)`
                  }}
                />
              </div>
              <div className="flex justify-between text-sm text-gray-600">
                <div className="space-x-1">
                  <span className="font-medium">{maxPrepTime}</span>
                  <span>minutes or less</span>
                </div>
                <div className="flex space-x-2">
                  {[30, 45, 60, 90].map(time => (
                    <button 
                      key={time}
                      onClick={() => setMaxPrepTime(time)}
                      className={`px-2 py-1 rounded ${maxPrepTime === time ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 hover:bg-gray-200'}`}
                    >
                      {time === 90 ? '1.5hr' : time === 60 ? '1hr' : `${time}min`}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Menu Types */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Menu Types</h3>
            <div className="grid grid-cols-3 gap-4">
              {[
                { id: 'classic', label: 'Classic Menu' },
                { id: 'essential', label: 'Popular Menu' },
                { id: 'seasonal', label: 'Seasonal Menu' }
              ].map(option => (
                <div key={option.id} className="flex items-center space-x-2">
                  <Checkbox
                    id={option.id}
                    checked={menuTypeFilters.includes(option.id)}
                    onCheckedChange={() => handleMenuTypeFilterChange(option.id)}
                  />
                  <Label htmlFor={option.id}>{option.label}</Label>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Search Bar */}
      <div className="bg-white rounded-lg shadow-sm p-4">
        <div className="relative">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search meals..."
            className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <svg
            className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default MealFilters; 